import * as Titularidad from '../constantes/Titularidad';
import * as FuncionesTiempo from './FuncionesTiempo.js';
import { PersonaFormacion as Campos } from '../constantes/Campos.js';
import * as Data from '../data/DataPartidos.js';
import { ItemFormacionVacio } from '../DTOs/FormacionDTOs.js';

export const Boton = {
  EDITAR: 'editar',
  CANCELAR: 'cancelar',
  BORRAR: 'borrar',
  GOL: 'gol',
  SALE: 'sale',
  ENTRA: 'entra',
  AMARILLA: 'amarilla',
  ROJA: 'roja',
};

export const ActualizarCampoJugador = (formacion, participante, campo, valor) => {
  return formacion.map((x) => {
    // Para identificar el participante correcto:
    // - Si el participante tiene idPartidoFormacion > 0, usarlo (registro ya guardado en BD)
    // - Si no, usar orden + titularidad (registros nuevos sin guardar)
    let esElParticipante = false;
    if (participante.idPartidoFormacion > 0) {
      esElParticipante = Number(x.idPartidoFormacion) === Number(participante.idPartidoFormacion);
    } else {
      esElParticipante =
        Number(x.orden) === Number(participante.orden) &&
        x.titularidad === participante.titularidad;
    }

    if (esElParticipante) {
      switch (campo) {
        case Campos.CAMISETA: {
          return { ...x, camiseta: valor, modificado: true };
        }
        case Campos.PERSONA: {
          return { ...x, persona: valor, personaSinId: null, modificado: true };
        }
        case Campos.PERSONA_SIN_ID: {
          return { ...x, personaSinId: valor, persona: null, modificado: true };
        }
        case Campos.AMONESTADO: {
          // Amonestación se graba independientemente, no marcar como modificado
          return { ...x, amonestado: valor };
        }
        default: {
          return x;
        }
      }
    } else {
      return x;
    }
  });
};

export const ActualizarExpulsionFormacion = (formacion, participante, datosExpulsion) => {
  return formacion.map((x) => {
    return Number(x.idPartidoFormacion) === Number(participante.idPartidoFormacion)
      ? {
          ...x,
          expulsado: datosExpulsion.expulsado,
          idExpulsion: Number(datosExpulsion.id),
          tiempoExpulsado: datosExpulsion.tiempo,
          minutosExpulsado: Number(datosExpulsion.minutos),
          tipoExpulsion: datosExpulsion.tipoExpulsion,
          // Expulsión se graba independientemente, no marcar como modificado
        }
      : x;
  });
};

export const ArmarPuestosFormacion = (idPartido, equipo, formacion, cantSuplentes) => {
  let resultado = [];
  if (equipo && formacion) {
    //Titulares
    for (var index = 1; index <= 11; index++) {
      const orden = index;
      const jugador = formacion.find(
        (puesto) =>
          puesto.titularidad &&
          puesto.titularidad !== Titularidad.DIRECTOR_TECNICO &&
          Number(puesto.orden) === Number(orden)
      );
      resultado = jugador
        ? [...resultado, jugador]
        : [...resultado, ItemFormacionVacio(idPartido, equipo, index, Titularidad.TITULAR)];
    }
    //Suplentes
    for (var index_ = 12; index_ <= 11 + cantSuplentes; index_++) {
      const orden = index_;
      const jugador = formacion.find(
        (puesto) =>
          puesto.titularidad &&
          puesto.titularidad !== Titularidad.DIRECTOR_TECNICO &&
          Number(puesto.orden) === Number(orden)
      );
      resultado = jugador
        ? [...resultado, jugador]
        : [...resultado, ItemFormacionVacio(idPartido, equipo, index_, Titularidad.SUPLENTE)];
    }
    //Directores técnicos
    let encontrado = false;
    for (const item of formacion) {
      if (item.titularidad === Titularidad.DIRECTOR_TECNICO) {
        encontrado = true;
        resultado = [...resultado, item];
      }
    }
    if (!encontrado) {
      resultado = [
        ...resultado,
        ItemFormacionVacio(idPartido, equipo, 12 + cantSuplentes, Titularidad.DIRECTOR_TECNICO),
      ];
    }
  } else {
    // se carga una formación vacía
    for (var k = 1; k <= 11; k++) {
      resultado = [...resultado, ItemFormacionVacio(idPartido, equipo, k, Titularidad.TITULAR)];
    }
    for (var l = 12; l <= 11 + cantSuplentes; l++) {
      resultado = [...resultado, ItemFormacionVacio(idPartido, equipo, l, Titularidad.SUPLENTE)];
    }
    //Director técnico
    resultado = [
      ...resultado,
      ItemFormacionVacio(idPartido, equipo, 12 + cantSuplentes, Titularidad.DIRECTOR_TECNICO),
    ];
  }
  return resultado;
};

export const GrabarFormacion = async (idPartido, idEquipo, formacion) => {
  let formacionGrabar = [];
  let nueva = true;
  let actualizar = false;

  formacion.map((x) => {
    if (x.idPartidoFormacion > 0) {
      nueva = false;
    }

    const tienePersona = x.persona && x.persona.id;
    const tienePersonaSinId =
      x.personaSinId && x.personaSinId.apellido && x.personaSinId.apellido.trim().length > 0;
    const tieneDatos = x.camiseta || tienePersona || tienePersonaSinId;
    const esNuevo = x.idPartidoFormacion < 1;
    const fueModificado = x.modificado === true;
    const esExistenteModificado = x.idPartidoFormacion > 0 && fueModificado;

    // Incluir si:
    // 1. Tiene datos Y (es nuevo O fue modificado)
    // 2. O es un registro existente que fue modificado (para enviar borrados/limpiezas)
    if ((tieneDatos && (esNuevo || fueModificado)) || esExistenteModificado) {
      formacionGrabar = [...formacionGrabar, x];
      // si se graban nuevos registros hay que actualizar la formación con los nuevos IDs
      if (esNuevo) {
        actualizar = true;
      }
    }
    return null;
  });

  // Si no hay nada que grabar, retornar false
  if (formacionGrabar.length === 0) {
    return false;
  }

  // Si no existían registros de formación hago un post, sino un put
  await (nueva
    ? Data.PostFormacion(idPartido, idEquipo, formacionGrabar)
    : Data.PutFormacion(idPartido, idEquipo, formacionGrabar));
  return actualizar;
};

export const ResetearModificados = (formacion) => {
  return formacion.map((x) => ({ ...x, modificado: false }));
};

export const ReordenarParticipante = (formacion, participante, direccion) => {
  // direccion: 'arriba' o 'abajo'
  // Solo reordena dentro del mismo grupo de titularidad (TITULAR o SUPLENTE)

  const participantesDelGrupo = formacion
    .filter(
      (p) =>
        p.titularidad === participante.titularidad && p.titularidad !== Titularidad.DIRECTOR_TECNICO
    )
    .sort((a, b) => a.orden - b.orden);

  const indiceActual = participantesDelGrupo.findIndex((p) => {
    if (participante.idPartidoFormacion > 0) {
      return p.idPartidoFormacion === participante.idPartidoFormacion;
    } else {
      return p.orden === participante.orden && p.titularidad === participante.titularidad;
    }
  });

  if (indiceActual === -1) return formacion;

  let indiceIntercambio = -1;
  if (direccion === 'arriba') {
    if (indiceActual === 0) return formacion; // Ya está en la primera posición
    indiceIntercambio = indiceActual - 1;
  } else if (direccion === 'abajo') {
    if (indiceActual === participantesDelGrupo.length - 1) return formacion; // Ya está en la última posición
    indiceIntercambio = indiceActual + 1;
  }

  if (indiceIntercambio === -1) return formacion;

  const participanteActual = participantesDelGrupo[indiceActual];
  const participanteIntercambio = participantesDelGrupo[indiceIntercambio];

  // Intercambiar los órdenes
  const ordenTemp = participanteActual.orden;
  const nuevoOrdenActual = participanteIntercambio.orden;
  const nuevoOrdenIntercambio = ordenTemp;

  // Actualizar la formación completa
  return formacion.map((p) => {
    // Identificar el participante actual
    const esParticipanteActual =
      participanteActual.idPartidoFormacion > 0
        ? p.idPartidoFormacion === participanteActual.idPartidoFormacion
        : p.orden === participanteActual.orden && p.titularidad === participanteActual.titularidad;

    // Identificar el participante a intercambiar
    const esParticipanteIntercambio =
      participanteIntercambio.idPartidoFormacion > 0
        ? p.idPartidoFormacion === participanteIntercambio.idPartidoFormacion
        : p.orden === participanteIntercambio.orden &&
          p.titularidad === participanteIntercambio.titularidad;

    if (esParticipanteActual) {
      return { ...p, orden: nuevoOrdenActual, modificado: true };
    } else if (esParticipanteIntercambio) {
      return { ...p, orden: nuevoOrdenIntercambio, modificado: true };
    } else {
      return p;
    }
  });
};

export const RemoverExpulsionFormacion = (formacion, participante) => {
  return formacion.map((x) => {
    return Number(x.idPartidoFormacion) === Number(participante.idPartidoFormacion)
      ? {
          ...x,
          expulsado: false,
          idExpulsion: null,
          tiempoExpulsado: null,
          minutosExpulsado: null,
          tipoExpulsion: null,
          // Expulsión se graba independientemente, no marcar como modificado
        }
      : x;
  });
};

export const SeparadoresVisibles = (tipoFormacion) => {
  let separadores = [];
  const separadoresFormacion =
    tipoFormacion && tipoFormacion.separadores && tipoFormacion.separadores.split(',');
  if (separadoresFormacion) {
    for (let index = 1; index < 11; index++) {
      separadores = [
        ...separadores,
        Boolean(separadoresFormacion.find((separador) => Number(separador) === Number(index))),
      ];
    }
  }
  return separadores;
};

export const ValidarCamisetaJugador = (formacion, jugador, numero) => {
  const encontrado = formacion.find((jugadorPuesto) => {
    // No validar contra el mismo jugador
    let esElMismoJugador = false;
    if (jugador.idPartidoFormacion > 0) {
      esElMismoJugador =
        Number(jugadorPuesto.idPartidoFormacion) === Number(jugador.idPartidoFormacion);
    } else {
      esElMismoJugador =
        Number(jugadorPuesto.orden) === Number(jugador.orden) &&
        jugadorPuesto.titularidad === jugador.titularidad;
    }

    return Number(jugadorPuesto.camiseta) === Number(numero) && !esElMismoJugador;
  });
  return encontrado === undefined;
};

export const ValidarMinutosGol = (participante, gol) => {
  let error = '';
  if (
    participante.idSustitucionEntra &&
    FuncionesTiempo.EsPrevio(
      gol.tiempo,
      gol.minutos,
      participante.tiempoEntra,
      participante.minutosEntra
    )
  ) {
    error = 'El gol es previo al ingreso del jugador';
  } else if (
    participante.idSustitucionSale &&
    FuncionesTiempo.EsPosterior(
      gol.tiempo,
      gol.minutos,
      participante.tiempoSale,
      participante.minutosSale
    )
  ) {
    error = 'El gol es posterior a la salida del jugador';
  } else if (
    participante.idExpulsion &&
    FuncionesTiempo.EsPosterior(
      gol.tiempo,
      gol.minutos,
      participante.tiempoExpulsado,
      participante.minutosExpulsado
    )
  ) {
    error = 'El gol es posterior a la expulsión del jugador';
  }
  return error;
};

export const ValidarMinutosSustitucion = (sustitucion, goles) => {
  let error = '';
  if (goles) {
    for (const gol of goles) {
      const idFormacionGol = gol.formacionJugador && gol.formacionJugador.idFormacion;
      if (
        idFormacionGol === sustitucion.idFormacionEntra &&
        FuncionesTiempo.EsPrevio(gol.tiempo, gol.minutos, sustitucion.tiempo, sustitucion.minutos)
      ) {
        error = 'El jugador que entra tiene un gol previo a su ingreso';
      } else if (
        idFormacionGol === sustitucion.idFormacionSale &&
        FuncionesTiempo.EsPosterior(
          gol.tiempo,
          gol.minutos,
          sustitucion.tiempo,
          sustitucion.minutos
        )
      ) {
        error = 'El jugador que sale tiene un gol posterior a su salida';
      }
    }
  }
  return error;
};

export const ValidarPersonaLibre = (formacion, jugador, persona) => {
  const encontrado = formacion.find((jugadorPuesto) => {
    // No validar contra el mismo jugador
    let esElMismoJugador = false;
    if (jugador.idPartidoFormacion > 0) {
      esElMismoJugador =
        Number(jugadorPuesto.idPartidoFormacion) === Number(jugador.idPartidoFormacion);
    } else {
      esElMismoJugador =
        Number(jugadorPuesto.orden) === Number(jugador.orden) &&
        jugadorPuesto.titularidad === jugador.titularidad;
    }

    return (
      jugadorPuesto.persona &&
      Number(jugadorPuesto.persona.id) === Number(persona.id) &&
      !esElMismoJugador
    );
  });
  return encontrado === undefined;
};
